import gql from "graphql-tag";

export default gql`
  mutation createComment(
    $orderId: ID!
    $responseTo: String
    $message: String
    $files: [S3ObjectInput]
  ) {
    createComment(
      orderId: $orderId
      responseTo: $responseTo
      message: $message
      files: $files
    ) {
      id
      orderId
      author
      responseTo
      createdAt
      updatedAt
      message
      files {
        bucket
        region
        key
        identityId
      }
      visibility
      isDeleted
      admin
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutation/CreateComment.js